<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="修改记录台账"
      width="85%"
      top="6vh"
      append-to-body>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sd/salesRevenueReport/editLog"
        :no-page="false">
      <div slot="toolbar">
        <el-button type="primary" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="组织">
            <el-input v-model.trim="filter.departmentName" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择</el-button>
            </el-input>
            <department-select ref="selectDepartment" @select="selectDepartment"/>
          </vm-search>
          <vm-search label="编辑类型">
            <el-select v-model="filter.editType" clearable placeholder="请选择" style="width: 150px">
              <el-option :value="1" label="目标"/>
              <el-option :value="2" label="增减收入"/>
              <el-option :value="3" label="已签收调整"/>
            </el-select>
          </vm-search>
          <vm-search label="开始月份">
            <el-date-picker v-model="filter.beginTime" value-format="yyyy-MM-dd" type="month" style="width: 140px"/>
          </vm-search>
          <vm-search label="结束月份">
            <el-date-picker v-model="filter.endTime" value-format="yyyy-MM-dd" type="month" style="width: 140px"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="departmentName" align="center" label="组织名称" min-width="140"/>
      <el-table-column prop="periodDate" align="center" label="期间" width="120"/>
      <el-table-column prop="editTypeName" align="center" label="编辑类型" width="110"/>
      <el-table-column prop="oldValue" align="center" label="原值" width="120"/>
      <el-table-column prop="newValue" align="center" label="新值" width="120"/>
      <el-table-column prop="remark" align="center" label="备注" min-width="140"/>
      <el-table-column prop="createBy" align="center" label="操作人" width="100"/>
      <el-table-column prop="createTime" align="center" label="操作时间" width="160"/>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "EditLogDialog",
    components: {VmTable, VmSearch, DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        filter: {
          departmentId: "",
          departmentName: "",
          editType: "",
          beginTime: "",
          endTime: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectDepartment(row) {
        this.filter.departmentId = row.departmentID;
        this.filter.departmentName = row.departmentName;
      },
      exportData() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        delete params.departmentName;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportEditLog", params)
          .then(resp => {
            this.exportLoading = false;
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
